module.exports = __webpack_public_path__ + "img/banner2.3a0d9646.png";